export default function nicer(data, { category, blurb, anchor } = {}) {
  return data.edges.map(item => ({
    id: item.node.id,
    headline: category ? item.node.frontmatter.category : `${item.node.frontmatter.date} • ${item.node.timeToRead} min`,
    title: item.node.frontmatter.title,
    link: (anchor ? anchor + '#' + item.node.id : false) || item.node.frontmatter.link || item.node.fields.slug,
    blurb: blurb && item.node.html
  }))
}
